/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import SettlementTimeSection from "@/src/components/Sections/Settlement/SettlementTimeSection/SettlementTimeSection";
import LpDismissalMeta from "./LpDismissalMeta";
import NoWinNoFeeSection from "@/src/components/Sections/Settlement/NoWinNoFeeSection/NoWinNoFeeSection";
import LandingPageTeaser from "@/src/components/Teaser/LandingPageTeaser";
import CustomerFeedback from "@/src/components/Sections/Generic/CustomerFeedback/CustomerFeedback";
import PartnersSection from "@/src/components/Sections/Generic/PartnersSection/PartnersSection";
import { getLastPathSplit } from "@/src/services/redirect";
import { landingPagesList } from "@/src/services/landingPagesList";
import accordionContentDismissal from "@/src/components/ControlledAccordion/accordionContentDismissal";
import ControlledAccordionSection from "@/src/components/Sections/Generic/ControlledAccordionSection/ControlledAccordionSection";
import TeamSection from "@/src/components/Sections/Generic/TeamSection/TeamSection";
import LinkedCardBox from "@/src/components/LinkedCardBox/LinkedCardBox";
import { settlementChoiceCards } from "@/src/services/landingPageService";
import Container from "@/src/components/Container/Container";
import { useLocation } from "react-router";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import HowItWorksSectionSettlement from "@/src/components/Sections/Settlement/HowItWorksSection/HowItWorksSectioSettlement";

const LpDismissal = () => {
  const location = useLocation();
  const lpKey = getLastPathSplit(location.pathname);
  const headline = (lpKey && landingPagesList[lpKey]?.headline) ?? "Abfindung bei Kündigung";
  const { isLoggedIn } = useCustomer();

  return (
    <LayoutPublicRoutes minimal={!isLoggedIn} clickableLogo={isLoggedIn}>
      <LpDismissalMeta />
      <LandingPageTeaser headline={headline} subheadline={"Wie können wir Ihnen helfen?"} hasTeaserButton={false}>
        <LinkedCardBox linkedCards={settlementChoiceCards} />
      </LandingPageTeaser>
      <ControlledAccordionSection contentList={accordionContentDismissal} idPrefix={"top"} name={"DismissalFaq"} heading={"Häufige Fragen zur Kündigung"} />
      <HowItWorksSectionSettlement />
      <NoWinNoFeeSection />
      <SettlementTimeSection />
      <TeamSection headline={"Sie möchten professionell gegen Ihre Kündigung angehen?"} subHeadline={"Wir kümmern uns persönlich um Sie"} />
      <CustomerFeedback />
      <Container>
        <LinkedCardBox linkedCards={settlementChoiceCards} />
      </Container>
      <PartnersSection />
    </LayoutPublicRoutes>
  );
};

export default LpDismissal;
